<template>
    <div>
        <b-tabs content-class="mt-3">
            <b-tab title="URLs" active>
                <b-table :fields="fields"
                         :items="items"
                         striped
                         selectable
                         select-mode="single"
                         selected-variant="primary"
                         @row-selected="selected_row"
                         head-variant="dark">
                    <template v-slot:cell(department)="data">
                        <b-input type="text" v-model="data.item.department"></b-input>
                    </template>
                    <template v-slot:cell(service)="data">
                        <b-input type="text" v-model="data.item.service"></b-input>
                    </template>
                    <template v-slot:cell(url)="data">
                        <b-input type="text" v-model="data.item.url"></b-input>
                    </template>
                    <template v-slot:cell(type)="data">
                        <b-form-select v-model="data.item.type">
                            <b-form-select-option value="Online">Online</b-form-select-option>
                            <b-form-select-option value="On-Campus">On-Campus</b-form-select-option>
                        </b-form-select>
                    </template>
                </b-table>
                <b-button variant="primary" @click="addnewrow">Add New Url</b-button>
                <b-button variant="danger" @click="deleteRow" class="ml-1" v-if="menu"><b-icon variant="light" icon="trash-fill"></b-icon></b-button>
                <b-button variant="danger" disabled class="ml-1" v-else><b-icon variant="light" icon="trash-fill"></b-icon></b-button>
                <b-button class="float-right" variant="primary" @click="saveAllRows">Save All</b-button>
                <div v-if="newrow" class="mt-3">
                    <b-row>
                        <b-col><b-input type="text" placeholder="Department" v-model="dpt"></b-input> </b-col>
                        <b-col><b-input type="text" placeholder="Service" v-model="srv"></b-input> </b-col>
                        <b-col><b-input type="text" placeholder="Url" v-model="url"></b-input> </b-col>
                        <b-col>
                            <b-form-select v-model="type">
                                <b-form-select-option value="Online">Online</b-form-select-option>
                                <b-form-select-option value="On-Campus">On-Ground</b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col><b-button variant="success" @click="postNewRow">Add</b-button><b-button class="ml-2" variant="danger" @click="resetadd">Cancel</b-button> </b-col>
                    </b-row>
                </div>
            </b-tab>
            <b-tab title="Text">
                <h4>Authentication Page</h4>
                <b-textarea v-model="atext" id="auth_textarea" placeholder="Html for the authentication page text." rows="8"></b-textarea>
                <hr>
                <h4>Clear Page</h4>
                <b-textarea v-model="ctext" id="clear_textarea" placeholder="Html for the clear page text." rows="8"></b-textarea>
                <hr>
                <h4>Not-Clear Page</h4>
                <b-textarea v-model="nctext" id="notclear_textarea" placeholder="Html for the not-clear page text." rows="8"></b-textarea>
                <hr>
                <b-button class="float-right" @click="saveAllText" variant="primary">Save All</b-button>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    export default {
        name: "editables",
        data(){
            return{
                selected:null,
                newrow:false,
                dpt:"",
                srv:"",
                url:"",
                type:"",
                atext:"",
                ctext:"",
                nctext:"",
                returning:{},
                busy:false,
            }
        },
        props:['fields','items','auth','authtext','cleartext','notcleartext'],
        methods:{
            selected_row(item){
                this.selected = item[0];
            },
            resetadd(){
                this.newrow = false;
            },
            addnewrow(){
                this.newrow = true;
            },
            deleteRow(){
                const formData = new FormData();
                formData.append("id", this.selected.id);
                let urlReq = 'https://itapplications.crc.ad.losrios.edu/CalmsApi/api/operations/deleteURL';
                this.$http.post(urlReq, formData, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Authorization': this.auth,
                        'Access-Control-Allow-Origin': '*',
                        'access-control-allow-credentials': 'true'
                    }
                }).then((result) => {
                    this.returning = result.data;
                    this.$emit('newrow');
                });
            },
            saveAllText(){
                this.busy = true;
                const formData = new FormData();
                formData.append("id", "1");
                formData.append("text", this.atext);
                let urlReq = 'https://itapplications.crc.ad.losrios.edu/CalmsApi/api/operations/updateApptText';
                this.$http.post(urlReq, formData, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Authorization': this.auth,
                        'Access-Control-Allow-Origin': '*',
                        'access-control-allow-credentials': 'true'
                    }
                }).then(() => {
                    const formData1 = new FormData();
                    formData1.append("id", "2");
                    formData1.append("text", this.ctext);
                    this.$http.post(urlReq, formData1, {
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8',
                            'Authorization': this.auth,
                            'Access-Control-Allow-Origin': '*',
                            'access-control-allow-credentials': 'true'
                        }
                    }).then(() => {
                        const formData2 = new FormData();
                        formData2.append("id", "3");
                        formData2.append("text", this.nctext);
                        this.$http.post(urlReq, formData2, {
                            headers: {
                                'Content-Type': 'application/json; charset=utf-8',
                                'Authorization': this.auth,
                                'Access-Control-Allow-Origin': '*',
                                'access-control-allow-credentials': 'true'
                            }
                        }).then((result) => {
                            this.returning = result.data;
                            this.busy = false;
                            this.$emit('gottext');
                        });
                    });
                });


            },
            saveAllRows(){
                this.busy = true;
                this.items.forEach((item) =>{
                    const formData = new FormData();
                    formData.append("dept", item.department);
                    formData.append("service", item.service);
                    formData.append("url", item.url);
                    formData.append("type", item.type);
                    formData.append("id", item.id);
                    let urlReq = 'https://itapplications.crc.ad.losrios.edu/CalmsApi/api/operations/updateURL';
                    this.$http.post(urlReq, formData, {
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8',
                            'Authorization': this.auth,
                            'Access-Control-Allow-Origin': '*',
                            'access-control-allow-credentials': 'true'
                        }
                    }).then((result) => {
                        this.returning = result.data;
                        this.busy = false;
                        this.$emit('newrow');
                    });
                });
            },
            postNewRow(){
                const formData = new FormData();
                formData.append("dept", this.dpt);
                formData.append("service", this.srv);
                formData.append("url", this.url);
                formData.append("type", this.type);
                let urlReq = 'https://itapplications.crc.ad.losrios.edu/CalmsApi/api/operations/newURL';
                this.$http.post(urlReq, formData, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Authorization': this.auth,
                        'Access-Control-Allow-Origin': '*',
                        'access-control-allow-credentials': 'true'
                    }
                }).then((result) => {
                    this.returning = result.data;
                    this.$emit('newrow');
                });
            }
        },
        computed:{
            menu(){
                if(this.selected != null){return true;}
                else{return false;}
            }
        },
        mounted(){
            this.atext = this.authtext;
            this.ctext = this.cleartext;
            this.nctext = this.notcleartext;
        }
    }
</script>

<style scoped>

</style>